import { useState, useEffect } from "react";
import { Accordion } from "./Accordion";
import type { FilterableSection } from "./FilterableList";

export function FilterableAccordion<T>({
  section,
  filteredItems,
  isFiltering,
}: {
  section: FilterableSection<T>;
  filteredItems: T[];
  isFiltering: boolean;
}) {
  const [isOpen, setIsOpen] = useState(section.defaultOpen ?? false);

  useEffect(() => {
    setIsOpen(isFiltering || (section.defaultOpen ?? false));
  }, [isFiltering, section.defaultOpen]);

  if (filteredItems.length === 0) return null;

  const total = section.items.length;
  const count = filteredItems.length === total ? total : `${filteredItems.length} / ${total}`;

  return (
    <Accordion title={section.title} count={count} isOpen={isOpen} onToggle={() => setIsOpen((prev) => !prev)} className={section.className}>
      {section.renderItems(filteredItems)}
    </Accordion>
  );
}
